export default "__VITE_ASSET__XCAwfp6Q__"